import { Link } from "react-router-dom";
import { renderToPlainText } from "common";
import { ProjectBanner, ProjectLogo } from "../../common/ProjectBanner";
import { BasicCard, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../../common/styles";
import { useCartStorage } from "../../../store";
import { CartButton } from "./CartButton";
import { useIsStakable } from "../ViewProjectDetails/components/StakingBannerAndModal/hooks/useIsStakable";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ProjectCard(props) {
  var _project$projectMetad, _props$crowdfundedUSD;
  const {
    project,
    roundRoutePath
  } = props;
  const {
    projects,
    add,
    remove
  } = useCartStorage();
  const isStakableRound = useIsStakable({
    chainId: Number(props.chainId),
    roundId: props.roundId
  });
  const isStakingPeriodStarted = props.showProjectCardFooter;
  const isAlreadyInCart = project && projects.some(cartProject => cartProject.chainId === Number(props.chainId) && cartProject.grantApplicationId === project.grantApplicationId && cartProject.roundId === props.roundId);
  if (!project) return null;
  const projectRecipient = project.recipient.slice(0, 5) + "..." + project.recipient.slice(-4);
  const cartProject = project;
  cartProject.roundId = props.roundId;
  cartProject.chainId = Number(props.chainId);
  return /*#__PURE__*/_jsxs(BasicCard, {
    className: `relative w-full ${props.showProjectCardFooter ? "h-[370px]" : "h-[310px]"}`,
    "data-testid": "project-card",
    children: [/*#__PURE__*/_jsxs(Link, {
      to: `${roundRoutePath}/${project.grantApplicationId}`,
      "data-testid": "project-detail-link",
      children: [/*#__PURE__*/_jsxs(CardHeader, {
        className: "relative",
        children: [/*#__PURE__*/_jsx(ProjectBanner, {
          bannerImgCid: (_project$projectMetad = project.projectMetadata.bannerImg) !== null && _project$projectMetad !== void 0 ? _project$projectMetad : null,
          classNameOverride: "bg-black h-[108px] w-full object-cover rounded-t",
          resizeHeight: 108
        }), isStakableRound && props.totalStaked !== undefined && isStakingPeriodStarted && /*#__PURE__*/_jsx(StakedAmountCard, {
          totalStaked: props.totalStaked
        })]
      }), /*#__PURE__*/_jsxs(CardContent, {
        className: "px-2 relative",
        children: [project.projectMetadata.logoImg && /*#__PURE__*/_jsx(ProjectLogo, {
          imageCid: project.projectMetadata.logoImg,
          size: 48,
          className: "ml-2 border-solid border-2 border-white absolute  -top-[24px] "
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(CardTitle, {
            "data-testid": "project-title",
            className: "text-xl",
            children: project.projectMetadata.title
          }), /*#__PURE__*/_jsxs(CardDescription, {
            className: "mb-2 mt-0 !text-sm",
            "data-testid": "project-owner",
            children: ["by ", /*#__PURE__*/_jsx("span", {
              className: "font-mono",
              children: projectRecipient
            })]
          })]
        }), /*#__PURE__*/_jsx(CardDescription, {
          "data-testid": "project-description",
          className: `mb-1 !text-sm`,
          children: renderToPlainText(project.projectMetadata.description)
        })]
      })]
    }), props.showProjectCardFooter && /*#__PURE__*/_jsx(CardFooter, {
      className: "bg-white",
      children: /*#__PURE__*/_jsx(CardContent, {
        className: "px-2 text-xs ",
        children: /*#__PURE__*/_jsxs("div", {
          className: "border-t pt-1 flex items-center justify-between ",
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs("p", {
              children: ["$", (_props$crowdfundedUSD = props.crowdfundedUSD) === null || _props$crowdfundedUSD === void 0 ? void 0 : _props$crowdfundedUSD.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })]
            }), /*#__PURE__*/_jsxs("p", {
              className: "text-[11px] font-mono",
              children: ["total raised by ", props.uniqueContributorsCount, " contributors"]
            })]
          }), props.isBeforeRoundEndDate && /*#__PURE__*/_jsx(CartButton, {
            project: project,
            isAlreadyInCart: isAlreadyInCart,
            removeFromCart: () => {
              remove(cartProject);
            },
            addToCart: () => {
              add(cartProject);
            },
            setCurrentProjectAddedToCart: props.setCurrentProjectAddedToCart,
            setShowCartNotification: props.setShowCartNotification
          })]
        })
      })
    })]
  });
}
const StakedAmountCard = _ref => {
  let {
    totalStaked
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "p-2 bg-white bg-opacity-80 rounded-2xl backdrop-blur-sm inline-flex justify-start items-center gap-2 absolute top-4 right-4",
    children: [/*#__PURE__*/_jsx("div", {
      className: "w-5 h-5 relative overflow-hidden",
      children: /*#__PURE__*/_jsx("div", {
        "data-svg-wrapper": true,
        className: "left-[3.33px] top-[2.50px] absolute",
        children: /*#__PURE__*/_jsx("svg", {
          width: "16",
          height: "18",
          viewBox: "0 0 16 18",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/_jsx("path", {
            d: "M8.83337 7.33333V1.5L1.33337 10.6667H7.16671L7.16671 16.5L14.6667 7.33333L8.83337 7.33333Z",
            stroke: "#7D67EB",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "inline-flex flex-col justify-start items-start",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "self-stretch inline-flex justify-start items-center gap-1",
        children: [/*#__PURE__*/_jsx("div", {
          className: "justify-start text-text-primary text-sm font-medium font-mono leading-normal",
          children: totalStaked.toFixed(3)
        }), /*#__PURE__*/_jsx("div", {
          className: "justify-start text-text-primary text-sm font-medium font-mono leading-normal",
          children: "GTC"
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "self-stretch justify-start text-text-primary text-xs font-normal font-mono leading-[14px]",
        children: "Total staked"
      })]
    })]
  });
};